var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1144"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1144"
    },
    "bundlingPackage": "customer-portal-app",
    "bundlingPackageVersion": "static-1.2216",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};